export interface SponsorTestimonial {
  name: string;
  title: string;
  content: string;
}

export const sponsorTestimonials: SponsorTestimonial[] = [
  {
    name: "The Financial Advisor",
    title: "Client Retention Scenario",
    content: "A client turns 70 and starts thinking about long-term care. Instead of losing visibility during that transition, you offer SeniorThrive as part of your advisory relationship, keeping you relevant and trusted."
  },
  {
    name: "The Estate Planning Attorney",
    title: "Holistic Client Care Scenario",
    content: "Your clients plan for what happens after they pass, but not for how they live safely today. SeniorThrive lets you extend your value beyond legal documents into daily independence and family coordination."
  },
  {
    name: "The Insurance Agent",
    title: "Risk Reduction Scenario",
    content: "Home safety directly affects claims. When your clients use SeniorThrive to identify and fix hazards, you are not just selling policies, you are actively helping them stay safer and reducing risk."
  }
];
